var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"create-course-modal"},[_c(_setup.CreateOrUpdateCourse,{attrs:{"editor-title":String(_vm.$t("editor.createCourse.createCourseTitle")),"create-course":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }